import { render, staticRenderFns } from "./RationsTable.vue?vue&type=template&id=796bf338&scoped=true&lang=pug&"
import script from "./RationsTable.vue?vue&type=script&lang=js&"
export * from "./RationsTable.vue?vue&type=script&lang=js&"
import style0 from "./RationsTable.vue?vue&type=style&index=0&id=796bf338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796bf338",
  null
  
)

export default component.exports